import { Url } from '@rossum/api-client';
import { Annotation } from '@rossum/api-client/annotations';
import { GridColDef } from '@rossum/ui/x-data-grid-pro';
import {
  useCalculateRulesPreview,
  UseCalculateRulesPreviewResult,
} from '../hooks/useCalculateRulesPreview';
import {
  columnsPrefix,
  constructRows,
  getDatapointsData,
  RowModel,
} from './helpers';

type TransformDataToRowsRulesParams = {
  columns: Array<GridColDef<RowModel>>;
  annotations: Annotation[];
  documentsMap: Record<string, string>;
  evaluationQueriesRules: ReturnType<typeof useCalculateRulesPreview>;
  showPreviewLine: boolean;
};

export const transformDataToRowsRules = ({
  columns,
  annotations,
  documentsMap,
  evaluationQueriesRules,
  showPreviewLine,
}: TransformDataToRowsRulesParams): Array<RowModel> => {
  const evaluationQueriesByAnnotationUrl: Record<
    Url,
    UseCalculateRulesPreviewResult
  > = Object.assign(
    {},
    ...evaluationQueriesRules.flatMap(query =>
      query.data?.content.type === 'from_annotation'
        ? [{ [query.data.content.annotationUrl]: query }]
        : [{ preview: query }]
    )
  );

  const previewLines = showPreviewLine
    ? [{ url: 'preview', document: '' }]
    : [];

  return [...previewLines, ...annotations].flatMap<RowModel>(
    ({ url: annotationUrl, document }) => {
      const datapointColumns = columns.filter(c =>
        c.field.startsWith(`${columnsPrefix}.`)
      );

      const evaluationQuery = evaluationQueriesByAnnotationUrl[annotationUrl];
      const evaluationData = evaluationQuery?.data;

      const datapointsData = getDatapointsData(
        evaluationQuery?.data?.annotationContent,
        datapointColumns,
        columnsPrefix
      );

      return constructRows({
        annotationUrl,
        document,
        documentsMap,
        datapointColumns,
        datapointsData,
        evaluationData,
        isFetching: evaluationQuery?.isFetching ?? false,
        messagesMap: evaluationData
          ? { all: evaluationData.messages }
          : undefined,
        previewMap: evaluationQueriesRules.find(
          q => q.data?.content.type === 'from_dependencies'
          // @ts-expect-error
        )?.data?.content.dependencies,
      });
    }
  );
};
